import { z } from "zod";

export const getVehicleDataByVinRequestSchema = z.object({
  vin: z.string(),
});

export type GetVehicleDataByVinRequest = z.infer<
  typeof getVehicleDataByVinRequestSchema
>;
